<template>
  <v-layout xs12 column align-center>
    <incentive-firings-filters
      ref="IncentiveFiringsFiltersRef"
      :loading="loading"
      @change="getFirings"
    />

    <incentive-firings-table
      :creditor="creditor"
      :items="items"
      :loading="loading"
      :total-items="totalItems"
    />
  </v-layout>
</template>

<script>
import IncentiveFiringsFilters from "./components/incentiveFiringsFilters.vue";
import IncentiveFiringsTable from "./components/incentiveFiringsTable.vue";

import IncentiveService from "@/services/incentives";

export default {
  name: "IncentiveFirings",
  components: {
    IncentiveFiringsFilters,
    IncentiveFiringsTable,
  },
  data() {
    return {
      items: [],
      filters: {},
      loading: false,
      totalItems: 0,
      creditor: null,
    };
  },
  mounted() {
    this.getFiltersFromUrl();
    this.getFirings();
  },
  methods: {
    getFirings(filters) {
      if (!filters) return;

      if (!filters.start_date || !filters.end_date) return;

      if (!filters.creditor_id) {
        this.creditor = null;
        this.$store.commit("showSnackbar", {
          message: "Por favor, selecione um credor para filtrar.",
        });
        return;
      }
      this.creditor = filters.creditor_id;

      const formattedFilters = { ...filters };
      if (Array.isArray(formattedFilters.gateway_id)) {
        formattedFilters.gateway_id = formattedFilters.gateway_id.join(',');
      }
      if (Array.isArray(formattedFilters.strategy_public)) {
        formattedFilters.strategy_public = formattedFilters.strategy_public.join(',');
      }
      if (Array.isArray(formattedFilters.approach_type)) {
        formattedFilters.approach_type = formattedFilters.approach_type.join(',');
      }

      this.loading = true;
      this.items = [];
      this.totalItems = 0;
      IncentiveService.getIncentiveFirings(formattedFilters)
        .then((response) => {
          if (response && response.data) {
            this.items = response.data || [];
            this.totalItems = response.num_objects || 0;
          }
          this.updateUrlWithFilters(filters);
        })
        .catch((e) => {
          console.error(e);
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao buscar os disparos de incentivos.",
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFiltersFromUrl() {
      const query = this.$route.query;
      const filters = {};

      Object.keys(query).forEach((key) => {
        if (key === "creditor_id") {
          filters[key] = parseInt(query[key], 10);
          return;
        }

        if (key === "gateway_id") {
          filters[key] = query[key].split(',').map(v => parseInt(v, 10));
          return;
        }

        if (["strategy_public", "approach_type"].includes(key)) {
          filters[key] = query[key].split(',');
          return;
        }

        filters[key] = query[key];
      });

      this.$refs.IncentiveFiringsFiltersRef.setFilters(filters);
    },
    updateUrlWithFilters(filters = {}) {
      const query = {};

      Object.keys(filters).forEach((key) => {
        if (!filters[key]) return;

        
        if (Array.isArray(filters[key])) {
          if (filters[key].length === 0) return;
          query[key] = filters[key].join(',');
          return;
        }

        query[key] = filters[key];
      });

      this.$router.replace({ query });
    },
  },
};
</script>
